export type NoteAttachmentEntry = {
  fileName: string;
  fileType: string;
  contentBase64: string;
};

export const noteAttachmentAccept = "image/*,application/pdf";

export const readNoteAttachmentFile = (file: File): Promise<NoteAttachmentEntry> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target?.result;
      if (typeof dataUrl !== "string") {
        reject(new Error("Failed to read file"));
        return;
      }
      const base64 = dataUrl.split(",")[1] ?? "";
      resolve({ fileName: file.name, fileType: file.type, contentBase64: base64 });
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
